<template style="height: 100%;">
  <div class="Already_test CommonContentSingle-white">
    <div class="search_cnt">
      <el-input v-model="content" :placeholder="$t('original.languages110')" class="text-search" style="width: 300px !important"  maxlength="15" :clearable="true"  @clear="removeall"></el-input>
      <el-button @click="loading(1)" type="primary" style="margin-left: 10px"> {{ $t('original.screening') }}</el-button>
    </div>
    <div class="already-content">
      <el-table v-loading="loadings" :row-key="(row) => {return row.PaperResultID;}" :data="tableData" style="width: 100%; margin-top: 10px" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column :label="$t('original.The_serial_number')" width="60px" align="center">
          <template slot-scope="scope" center>
            {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('original.Name_of_scale')" min-width="200" align="left">
          <template slot-scope="scope" align="left">
            <span>{{ scope.row.PaperName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('original.account')">
          <template slot-scope="scope">
            <span>{{ scope.row.UserID }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('original.name')">
          <template slot-scope="scope">
            <span>{{ scope.row.RealName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('original.languages113')" min-width="150">
          <template slot-scope="scope">
            <span>
              {{ scope.row.PubName ? scope.row.PubName : "全部量表测试" }}
            </span>
          </template>
        </el-table-column>
        
        <el-table-column :label="$t('original.languages170')" width="200" align="center">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <span style="margin-left: 10px">{{ scope.row.StartTime }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages152')">
          <template slot-scope="scope">
            <span>{{ scope.row.SETime }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages147')">
          <template slot-scope="scope">
            <span>{{ scope.row.IsSubmit }}</span>
          </template>
        </el-table-column>

      </el-table>

      <div class="block">
        <el-pagination  @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page.sync="currentPage1"  :page-size="10" layout="total, prev, pager, next" :hide-on-single-page="wpppd" :total="Counts"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      wpppd:true,
      pageIndex: 1,
      loadings: false,
      content: "",
      tableData: [],
      Counts: 1,
      currentPage1: 1,
      formInline: {
        Name: "",
        Student: "",
        ScaleName: "",
        TestTime: "",
        PublishID: "",
        ObjectS: "",
        StudyTime: "",
        Warning: "",
      },
    };
  },
  methods: {
    handleEdit(index, row) {
      this.$router.push({
        path: "/measurement/PaperTest",
        query: { PaperID: row.PaperID },
      });
    },
    handleDelete(index, row) {},
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.loading(val);
    },
    loading(num) {
      this.pageIndex = num;
      let from;
      this.loadings = true;
      this.$Http_Post("ScaleIssue/GetLfzMeasuredText",{content: this.content.replace(/\s*/g, ""),pageSize: "10",pageIndex: num,})
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          if(res.Data.Counts >=10){this.wpppd = false}else{this.wpppd = true}
          this.loadings = false;
          this.tableData = res.Data;
          this.Counts = Number(res.Counts);
        } else {
          this.loadings = false;
          this.Global.request_failure(res.Message);
        }
      })
      .catch((err) => {
        this.$message({
          type: "error",
          message: err.message,
        });
      });
    },
    resetForm() {
      this.content = "";
      this.loading(1);
    },
    removeall() {
      this.loading(1);
    },
  },
  mounted() {
    this.loading(1);
  },
};
</script>
<style>
.Already_test h2 {font-size: 20px;padding-bottom: 20px;}
.Already_test .block {float: right;margin-top: 0px;}
.Already_test .el-input {width: 100% !important;}
.Already_test .search_cnt {text-align: center;}
.Already_test .search_cnt .s-cnt {width: 460px;}
.already-content{height: calc(100% - 40px);overflow: auto;}
</style>
